import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import { useLoadProgress } from '../hooks/useLoadProgress'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    // login: true,
    login: false,
    title: '紙上的編號',
    placeholder: 'T000',
    alert: '編號有誤，請重新輸入，或請工作人員協助',
    useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const isWantsPregnant =
    '(({q6} >= 15 and {q6} <= 46) or ({q10} >= 15 and {q10} <= 46)) and ({q11} = 1) and ({q33} = 1 or {q33} = 2 or {q34} = 1) and ({q179} = 0) and ({q182} = 3 or {q182} = 4 or {q182} = 5)'
  // 已停經
  const isPostmenopausal =
    '(({q6} >= 5 and {q6} <= 24) or ({q10} >= 5 and {q10} <= 24)) and ({q11} = 1) and ({q182} = 0)'
  const isRecentDrinker = '({q253} = 0 or {q253} = 1)'

  const visibleIfConditionsInit = {
    q1: '{q0} = 100', // 隱藏
    q2: '{q0} = 100', // 隱藏
    q4: '{q3} = 1',
    q5: '({q3} = 1) and ({q4} = 0)',

    q6: '({q4} = 0)',
    q7: '({q4} = 0)',
    q8: '({q4} = 0)',

    q9: '({q4} = 1)',
    q10: '({q4} = 1)',

    q13: '{q12} = 7 or {q12} = 10 or {q12} = 13 or {q12} = 15 or {q12} = 17 or {q12} = 18',

    q15: '{q14} = 0',
    q16: '{q14} = 1',
    // A5
    q18: '{q17} = 0',
    q19: '({q17} = 0) and ({q18} anyof [0])',
    q20: '({q17} = 0) and ({q18} anyof [1])',
    q21: '({q17} = 0) and ({q18} anyof [2])',
    q22: '({q17} = 0) and ({q18} anyof [3])',
    q23: '({q17} = 0) and ({q18} anyof [4])',
    q24: '({q17} = 0) and ({q18} anyof [5])',
    q25: '({q17} = 0) and ({q18} anyof [6])',
    q26: '({q17} = 0) and ({q18} anyof [7])',
    q27: '({q17} = 0) and ({q18} anyof [8])',
    q28: '({q17} = 0) and ({q18} anyof [9])',
    q29: '({q17} = 0) and ({q18} anyof [10])',
    q30: '({q17} = 0) and ({q18} anyof [11])',
    q31: '({q17} = 0) and ({q18} anyof [12])',
    q32: '{q17} = 0',
    // A6
    q34: '{q33} = 0 or {q33} = 3 or {q33} = 4 or {q33} = 5 or {q33} = "other"',
    q35: '{q33} = 1 or {q33} = 2 or {q34} = 1',
    q36: '({q33} = 1 or {q33} = 2 or {q34} = 1) and ({q35} = 0)',
    q37: '({q33} = 1 or {q33} = 2 or {q34} = 1) and ({q35} = 1 or {q35} = 2)',
    q38: '({q33} = 1 or {q33} = 2 or {q34} = 1) and ({q35} = 0 or {q35} = 1 or {q35} = 2)',
    q39: '{q33} = 1 or {q33} = 2 or {q34} = 1',
    q40: '({q33} = 1 or {q33} = 2 or {q34} = 1) and ({q39} = 7 or {q39} = 10 or {q39} = 13 or {q39} = 15 or {q39} = 17 or {q39} = 18)',
    // A7
    q42: '{q41} = 0',
    q43: '{q41} = 1 or {q41} = 2',
    q45: '{q44} = 0',
    q46: '{q44} = 1 or {q44} = 2',
    // B3
    q50: '{q49} = 1',
    q51: '({q49} = 1) and ({q50} = 1)',
    q52: '({q49} = 1) and ({q50} = 1) and ({q51} = 1)',
    q53: '{q49} = 1',
    // B4
    q55: '{q54} = 1',
    q56: '({q54} = 1) and ({q55} = 1)',
    q57: '({q54} = 1) and ({q55} = 1)',
    q58: '({q54} = 1) and ({q55} = 1) and ({q57} = 1)',
    q59: '{q54} = 1',
    q60: '{q54} = 1',
    q61: '{q54} = 1',
    q62: '({q54} = 1) and ({q61} = 1)',
    q63: '{q54} = 1',
    q64: '{q54} = 1',
    q65: '({q54} = 1) and ({q64} = 1)',
    q66: '{q54} = 1',
    q67: '({q54} = 1) and ({q66} = 1)',
    // B5
    q69: '{q68} = 1',
    q70: '({q68} = 1) and ({q69} = 1)',
    q71: '({q68} = 1) and ({q69} = 1) and ({q70} = 1)',
    q72: '{q68} = 1',
    // B6
    q73: '({q49} = 1) or ({q54} = 1) or ({q68} = 1)',
    // B7
    q75: '{q74} = 1',
    q76: '{q74} = 1',
    q77: '{q74} = 1',
    q78: '({q74} = 1) and ({q77} = "other")',
    q79: '({q74} = 1) and ({q77} = 0)',
    q80: '{q74} = 1',
    q81: '({q74} = 1) and ({q80} = 1)',
    // B8
    q83: '{q82} = 1',
    q84: '{q83} = 1',
    q85: '{q83} = 1',
    q86: '{q83} = 1',
    q87: '{q83} = 1',
    q88: '{q83} = 1',
    q89: '{q83} = 1',
    q90: '{q83} = 1',
    // B9
    q96: '{q95} = 1',
    // B10
    q98: '{q97} = 1',
    q99: '{q97} = 1',
    q100: '({q97} = 1) and ({q99} = 1)',
    q101: '({q97} = 1) and ({q99} = 1) and ({q100} = 0)',
    q102: '({q97} = 1) and ({q99} = 1) and ({q100} = 1)',
    q103: '({q97} = 1) and ({q99} = 1)',
    // B11
    q105: '{q104} = 1',
    q106: '{q104} = 1',
    q107: '({q104} = 1) and ({q106} = 1)',
    q108: '({q104} = 1) and ({q106} = 1) and ({q107} = 0)',
    q109: '({q104} = 1) and ({q106} = 1) and ({q107} = 1)',
    q110: '({q104} = 1) and ({q106} = 1)',
    q111: '({q104} = 1) and ({q106} = 1) and ({q107} = 1)',
    // B11
    q116: '{q115} = 1',
    q117: '{q115} = 1',
    q118: '({q115} = 1) and ({q117} = 1)',
    q119: '{q115} = 1',
    // B12 癌症
    q120: '{q11} = 0 or {q11} = 2',
    q121: '{q11} = 1',

    q122: '({q120} anyof [5]) or ({q121} anyof [5])',
    q123: '({q120} anyof [5]) or ({q121} anyof [5])',
    // B12 心臟
    q124: '({q120} anyof [0]) or ({q121} anyof [0])',
    q125: '({q120} anyof [0]) or ({q121} anyof [0])',
    q126: '({q120} anyof [0]) or ({q121} anyof [0])',
    // B12 痛風
    q127: '({q120} anyof [1]) or ({q121} anyof [1])',
    q128: '({q120} anyof [1]) or ({q121} anyof [1])',
    q129: '({q120} anyof [1]) or ({q121} anyof [1])',
    // B12 胃潰瘍或十二指腸潰瘍
    q130: '({q120} anyof [2]) or ({q121} anyof [2])',
    q131: '({q120} anyof [2]) or ({q121} anyof [2])',
    q132: '({q120} anyof [2]) or ({q121} anyof [2])',
    // B12 肝膽疾病
    q133: '({q120} anyof [3]) or ({q121} anyof [3])',
    q134: '({q120} anyof [3]) or ({q121} anyof [3])',
    q135: '({q120} anyof [3]) or ({q121} anyof [3])',
    // B12 骨質疏鬆
    q136: '({q120} anyof [4]) or ({q121} anyof [4])',
    q137: '({q120} anyof [4]) or ({q121} anyof [4])',
    // B12 癌症
    q138: '({q120} anyof [5]) or ({q121} anyof [5])',
    q139: '({q120} anyof [5]) or ({q121} anyof [5])',
    q140: '({q120} anyof [5]) or ({q121} anyof [5])',
    q141: '({q120} anyof [5]) or ({q121} anyof [5]) and ({q123} != 20)',
    q142: '({q120} anyof [5]) or ({q121} anyof [5]) and ({q123} != 20)',
    q143: '({q120} anyof [5]) or ({q121} anyof [5]) and ({q123} != 20)',
    // B12 關節炎
    q144: '({q120} anyof [6]) or ({q121} anyof [6])',
    q145: '({q120} anyof [6]) or ({q121} anyof [6])',
    q146: '({q120} anyof [6]) or ({q121} anyof [6])',
    // B12 憂鬱症
    q147: '({q120} anyof [7]) or ({q121} anyof [7])',
    q148: '({q120} anyof [7]) or ({q121} anyof [7])',
    q149: '({q120} anyof [7]) or ({q121} anyof [7])',
    // B12 思覺失調症
    q150: '({q120} anyof [8]) or ({q121} anyof [8])',
    q151: '({q120} anyof [8]) or ({q121} anyof [8])',
    q152: '({q120} anyof [8]) or ({q121} anyof [8])',
    // B12 其他精神疾病
    q153: '({q120} anyof [9]) or ({q121} anyof [9])',
    q154: '({q120} anyof [9]) or ({q121} anyof [9])',
    q155: '({q120} anyof [9]) or ({q121} anyof [9])',
    // B12 非癌症之攝護腺問題【限問男性】
    q156: '({q120} anyof [10]) and ({q11} = 0)',
    q157: '({q120} anyof [10]) and ({q11} = 0)',
    q158: '({q120} anyof [10]) and ({q11} = 0)',
    // 子宮卵巢疾病(不包括子宮卵巢癌)【限問女性】
    q159: '({q121} anyof [10]) and ({q11} = 1)',
    q160: '({q121} anyof [10]) and ({q11} = 1)',
    q161: '({q121} anyof [10]) and ({q11} = 1)',
    // B13
    q165: '{q164} = 0',
    q166: '{q164} = 1 or {q164} = 2 or {q164} = 3',
    q167: '({q165} = 1 or {q165} = 2 or {q165} = 3) or ({q166} = 1 or {q166} = 2 or {q166} = 3)',
    q168: '{q167} = 1',
    // B14
    q170: '{q169} = 1 or {q169} = "other"',
    q171: '({q169} = 1 or {q169} = "other") and ({q170} anyof [0])',
    q172: '({q169} = 1 or {q169} = "other") and ({q170} anyof [1] or {q171} = 0)',
    q175: '({q6} >= 15 and {q6} <= 46) or ({q10} >= 15 and {q10} <= 46)',
    q176: '{q175} = 1',
    q177: '{q175} = 1',
    q178: '{q175} = 1',
    q180: '{q179} = 1',
    q181: '{q179} = 1',
    // B16
    q182: '{q11} = 1',
    // B17
    q183: isWantsPregnant,
    q184: isWantsPregnant + ' and ({q183} = 1 or {q183} = 2)',
    q185: isWantsPregnant + ' and ({q183} = 1 or {q183} = 2) and ({q184} = 1)',
    q186: isWantsPregnant + ' and ({q183} = 1 or {q183} = 2) and ({q184} = 0)',
    // B18
    q187: isPostmenopausal,
    q188: isPostmenopausal,
    q189: isPostmenopausal + ' and ({q188} = 1)',
    q190: isPostmenopausal + ' and ({q188} = 1)',
    q191: isPostmenopausal + ' and ({q188} = 1) and ({q190} = 1)',
    q192: isPostmenopausal + ' and ({q188} = 1)',
    q193: isPostmenopausal + ' and ({q188} = 1) and ({q192} = 1)',
    q194: isPostmenopausal + ' and ({q188} = 0 or {q188} = 1 or {q188} = 3)',
    q195: isPostmenopausal + ' and ({q188} = 0 or {q188} = 1 or {q188} = 3)',
    q196: isPostmenopausal + ' and ({q188} = 0 or {q188} = 1 or {q188} = 3)',
    // B19
    q198: '{q197} = 0',
    q199: '{q197} = 1 or {q197} = 2 or {q197} = 3',
    // C1
    q205: '{q204} = 2',
    q212: '{q211} = 1',
    q214: '{q213} = 1',
    q216: '{q215} = 1',
    q218: '{q217} = 1',

    // C4
    // q219: '{q217} = 1',
    q220: '(({q6} >= 0 and {q6} <= 24) or ({q10} >= 0 and {q10} <= 24)) and {q219} = 1',
    q221: '{q219} = 1 and {q220} = 0',
    // C5
    q223: '{q222} = 1',
    q224: '{q222} = 0',
    // C6
    q226: '{q225} = 1',
    q227: '{q225} = 1',
    // C7
    q229: '{q228} = 1',
    // C8
    // 留己看 測試不寫一堆&&
    q230: '(({q6} >= 20 and {q6} <= 24) or ({q10} >= 20 and {q10} <= 24)) and {q11} = 1',
    q231: '((({q6} >= 0 and {q6} <= 19) or ({q10} >= 0 and {q10} <= 19)) and {q11} = 1) or ({q230} = 1)',
    q232: '{q231} = 1',
    q233: '({q231} = 0) or ({q232} = 2 or {q232} = 3 or {q232} = 4)',
    q234: '({q231} = 2 or {q231} = 3 or {q231} = 4) or ({q232} = 2 or {q232} = 3 or {q232} = 4)',
    q235: '{q234} = 1',
    // C9
    q236: '({q6} >= 19 and {q6} <= 46) or ({q10} >= 19 and {q10} <= 46)',
    q237: '(({q6} >= 0 and {q6} <= 34) or ({q10} >= 0 and {q10} <= 34)) and {q11} = 1',
    q238: '{q237} = 1',
    q239: '{q237} = 0 or {q238} = 3 or {q238} = 4',
    q240: '(({q6} >= 0 and {q6} <= 34) or ({q10} >= 0 and {q10} <= 34)) and {q11} = 1',
    q241: '{q240} = 1',
    // C10
    q242: '({q6} >= 0 and {q6} <= 14) or ({q10} >= 0 and {q10} <= 14)',
    q243: '{q242} = 1',
    q244: '{q242} = 0',
    q245: '({q6} >= 0 and {q6} <= 24) or ({q10} >= 0 and {q10} <= 24)',
    q246: '{q245} = 1',
    // C11
    q247: '({q6} >= 0 and {q6} <= 44) or ({q10} >= 0 and {q10} <= 44)',
    q248: '{q247} = 1',
    q249: '{q247} = 1',
    q250: '{q247} = 1',
    // D1
    q252: '{q251} = 1',
    q253: '{q251} = 1',
    q254: '({q251} = 1) and ({q253} = 0 or {q253} = 1 or {q253} = 2 or {q253} = 3)',

    q255: isRecentDrinker,
    q256: isRecentDrinker + ' and ({q255} anyof [0])',
    q257: isRecentDrinker + ' and ({q255} anyof [0])',
    q258: isRecentDrinker + ' and ({q255} anyof [0])',
    q259: isRecentDrinker + ' and ({q255} anyof [1])',
    q260: isRecentDrinker + ' and ({q255} anyof [1])',
    q261: isRecentDrinker + ' and ({q255} anyof [1])',
    q262: isRecentDrinker + ' and ({q255} anyof [2])',
    q263: isRecentDrinker + ' and ({q255} anyof [2])',
    q264: isRecentDrinker + ' and ({q255} anyof [2])',
    q265: isRecentDrinker + ' and ({q255} anyof [3])',
    q266: isRecentDrinker + ' and ({q255} anyof [3])',
    q267: isRecentDrinker + ' and ({q255} anyof [3])',
    q268: isRecentDrinker + ' and ({q255} anyof [4])',
    q269: isRecentDrinker + ' and ({q255} anyof [4])',
    q270: isRecentDrinker + ' and ({q255} anyof [4])',
    q271: isRecentDrinker + ' and ({q255} anyof [5])',
    q272: isRecentDrinker + ' and ({q255} anyof [5])',
    q273: isRecentDrinker + ' and ({q255} anyof [5])',
    q274: isRecentDrinker + ' and ({q255} anyof [6])',
    q275: isRecentDrinker + ' and ({q255} anyof [6])',
    q276: isRecentDrinker + ' and ({q255} anyof [6])',
    q277: isRecentDrinker + ' and ({q255} anyof [7])',
    q278: isRecentDrinker + ' and ({q255} anyof [7])',
    q279: isRecentDrinker + ' and ({q255} anyof [7])',
    q280: isRecentDrinker + ' and ({q255} anyof [8])',
    q281: isRecentDrinker + ' and ({q255} anyof [8])',
    q282: isRecentDrinker + ' and ({q255} anyof [8])',

    q283: isRecentDrinker,
    q284: isRecentDrinker + ' and ({q283} = 0)',
    q285: isRecentDrinker + ' and ({q283} = 0)',
    q286: isRecentDrinker + ' and ({q283} = 0)',
    q287: isRecentDrinker + ' and ({q283} = 1)',
    q288: isRecentDrinker + ' and ({q283} = 1)',
    q289: isRecentDrinker + ' and ({q283} = 1)',
    q290: isRecentDrinker + ' and ({q283} = 2)',
    q291: isRecentDrinker + ' and ({q283} = 2)',
    q292: isRecentDrinker + ' and ({q283} = 2)',
    q293: isRecentDrinker + ' and ({q283} = 3)',
    q294: isRecentDrinker + ' and ({q283} = 3)',
    q295: isRecentDrinker + ' and ({q283} = 3)',
    q296: isRecentDrinker + ' and ({q283} = 4)',
    q297: isRecentDrinker + ' and ({q283} = 4)',
    q298: isRecentDrinker + ' and ({q283} = 4)',
    q299: isRecentDrinker + ' and ({q283} = 5)',
    q300: isRecentDrinker + ' and ({q283} = 5)',
    q301: isRecentDrinker + ' and ({q283} = 5)',
    q302: isRecentDrinker + ' and ({q283} = 6)',
    q303: isRecentDrinker + ' and ({q283} = 6)',
    q304: isRecentDrinker + ' and ({q283} = 6)',
    q305: isRecentDrinker + ' and ({q283} = 7)',
    q306: isRecentDrinker + ' and ({q283} = 7)',
    q307: isRecentDrinker + ' and ({q283} = 7)',
    q308: isRecentDrinker + ' and ({q283} = 8)',
    q309: isRecentDrinker + ' and ({q283} = 8)',
    q310: isRecentDrinker + ' and ({q283} = 8)',

    q311: isRecentDrinker,
    q312: '({q251} = 1) and ({q253} = 0 or {q253} = 1 or {q253} = 2 or {q253} = 3)',
    q313: '({q251} = 1) and ({q253} = 0 or {q253} = 1 or {q253} = 2 or {q253} = 3) and ({q312} = 1 or {q312} = 2)',
    q314: '({q251} = 1) and ({q253} = 0 or {q253} = 1 or {q253} = 2 or {q253} = 3)',
    q315: '({q251} = 1) and ({q253} = 0 or {q253} = 1 or {q253} = 2 or {q253} = 3) and ({q314} = 1)',
    q318: '({q317} = 100)', // 隱藏
    // D2
    q320: '{q319} = 1 or {q319} = 2',
    q321: '({q319} = 1 or {q319} = 2) and ({q320} = 1)',
    q322: '({q319} = 1 or {q319} = 2) and ({q320} = 0)',
    q323: '({q319} = 1 or {q319} = 2) and ({q320} = 1)',
    q324: '({q319} = 1 or {q319} = 2)',
    q325: '({q319} = 1 or {q319} = 2) and ({q324} = "other")',
    q326: '({q319} = 1 or {q319} = 2) and ({q324} = "other") and ({q325} = 1)',
    // D2e
    q328: '{q327} = 1 or {q327} = 2',
    q329: '({q327} = 1 or {q327} = 2) and ({q328} = 1 or {q328} = 2)',
    q331: '{q330} = 1 or {q330} = 2',
    q332: '({q330} = 1 or {q330} = 2) and ({q331} = 1 or {q331} = 2)',
    q334: '{q333} = 1 or {q333} = 2',
    q335: '({q333} = 1 or {q333} = 2) and ({q334} = 1 or {q334} = 2)',
    q337: '{q336} = 1 or {q336} = 2',
    q338: '({q336} = 1 or {q336} = 2) and ({q337} = 1 or {q337} = 2)',
    q340: '{q339} = 1 or {q339} = 2',
    q341: '({q339} = 1 or {q339} = 2) and ({q340} = 1 or {q340} = 2)',
    q343: '{q342} = 1 or {q342} = 2',
    q344: '({q342} = 1 or {q342} = 2) and ({q343} = 1 or {q343} = 2)',
    q346: '{q345} = "other"',
    q347: '{q345} = "other"',
    q348: '({q345} = "other") and ({q347} = 1 or {q347} = 2)',
    // D3
    q350: '{q349} = 1',
    q351: '{q349} = 1 and {q350} = 1',
    q352: '{q349} = 1',
    q353: '{q349} = 1',
    q354: '{q349} = 1',
    q355: '{q349} = 1',
    q356: '{q349} = 1',
    // D4
    q358: '{q357} = 2',
    q359: '({q357} = 2) and ({q358} = 0)',
    q360: '({q357} = 2) and ({q358} = 0)',
    q361: '({q357} = 2) and ({q358} = 0)',
    q362: '({q357} = 2) and ({q358} = 0)',
    q363: '({q357} = 2) and ({q358} = 0)',
    q364: '({q357} = 2) and ({q358} = 1)',
    q365: '({q357} = 2) and ({q358} = 1) and ({q364} = 1 or {q364} = 2 or {q364} = 3 or {q364} = 4)',
    q366: '({q357} = 2) and ({q358} = 1) and ({q364} = 1 or {q364} = 2 or {q364} = 3 or {q364} = 4) and ({q365} = 0)',
    q367: '({q357} = 2) and ({q358} = 1)',
    q368: '({q357} = 2) and ({q358} = 1)',
    q369: '({q357} = 2) and ({q358} = 1) and ({q368} = 1)',
    q370: '({q357} = 2) and ({q358} = 1)',
    q371: '({q357} = 2) and ({q358} = 1)',
    q372: '({q357} = 2) and ({q358} = 1) and ({q371} = 1)',
    q373: '({q357} = 2) and ({q358} = 1) and ({q371} = 1)',
    q374: '({q357} = 2) and ({q358} = 1) and ({q371} = 1)',
    q375: '({q357} = 2) and ({q358} = 1)',
    q376: '({q357} = 2) and ({q358} = 1)',
    // D5
    q378: '(({q6} >= 0 and {q6} <= 34) or ({q10} >= 0 and {q10} <= 34)) and ({q319} = 2 or {q357} = 2) or (({q6} >= 34 and {q6} <= 46) or ({q10} >= 34 and {q10} <= 46)) and ({q357} = 2) and ({q15} = 1)',

    q379: '{q378} = 1',
    q380: '({q378} = 0) or ({q378} = 1 and ({q379} = 2 or {q379} = 3 or {q379} = 4))',
    // D6
    q382: '{q381} = 0',
    q384: '{q383} = 1',
    // D7
    q389: '{q388} = 0 or {q388} = 1',
    // D8
    q391: '{q390} = 1 or {q390} = 2 or {q390} = 3 or {q390} = 4 or {q390} = 5 or {q390} = 6 or {q390} = 7',
    q393: '{q392} = 1 or {q392} = 2 or {q392} = 3 or {q392} = 4 or {q392} = 5 or {q392} = 6 or {q392} = 7',
    // D10
    q396: '{q395} = 1',
    q397: '{q395} = 1',
    q399: '{q398} = 1',
    q400: '{q398} = 1',
    q402: '{q401} = 1',
    q403: '{q402} = 1 or {q402} = 2 or {q402} = 3 or {q402} = 4 or {q402} = 5 or {q402} = 6 or {q402} = 7',
    q404: '{q401} = 1',
    q405: '{q404} = 1 or {q404} = 2 or {q404} = 3 or {q404} = 4 or {q404} = 5 or {q404} = 6 or {q404} = 7',
    q407: '{q406} = 1',
    q408: '{q406} = 1',
    q410: '{q409} = 1',
    q411: '{q409} = 1',
    // D12
    q414: '{q413} = 1',
    q415: '{q413} = 1',
    q416: '({q413} = 1) and ({q415} = 0 or {q415} = 1 or {q415} = 2 or {q415} = 3 or {q415} = 5)',
    // G1
    q428: '{q427} = 0',
    q429: '{q427} = 1',
    q430: '{q427} = 2',
    q431: '{q427} = 2',
    q432: '{q427} = 2',
    q433: '{q427} = 2',
    q434: '{q427} = 2',
    q435: '({q427} = 2) and ({q434} = 0)',
    q436: '({q427} = 2) and ({q434} = 1 or {q434} = 3)',
    q437: '{q427} = 2',
    // G2
    q439: '{q438} = 0 or {q438} = 2 or {q438} = 3',
    q443: '{q442} = 1',
    // I0
    q452: '{q451} anyof [0, 1, 2, 3]',
    q453: '({q451} anyof [0, 1, 2, 3]) and ({q452} = 1)',
    q454: '({q451} anyof [0, 1, 2, 3]) and ({q452} = 1)',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = [381]

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    // 暫存需加
    userIdRef,
    choiceIndexMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 暫存需加
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  // 暫存需加
  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // 暫存需加
  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `我們的訪問到這邊告一段落，非常謝謝您的協助！`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue('q0') === 1) {
    setCompletionMessage(endMessage)
    // } else {
    //   setCompletionMessage(
    //     `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    //   )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
